const getDefaultState = () => ({
  domains: {
    items: [],
    loading: false,
    error: false,
    noContent: false,
  },
  templates: {
    domain: undefined,
    templates: {
      items: [],
      loading: false,
      error: false,
      noContent: false,
    },
    save: {
      loading: false,
      error: false,
    },
  },
  rules: {
    domain: undefined,
    currentRevision: undefined,
    rules: {
      item: {},
      loading: false,
      error: false,
      noContent: false,
    },
    templates: {
      items: [],
      loading: false,
      error: false,
      noContent: false,
    },
    save: {
      loading: false,
      error: false,
    },
    revisions: {
      items: [],
      loading: false,
      error: false,
      noContent: false,
    },
    settings: {
      list: {
        items: [],
        loading: false,
        error: false,
        noContent: false,
      },
      logs: {
        items: [],
        loading: false,
        error: false,
      },
      action: {
        loading: false,
        error: false,
      },
      delete: {
        loading: false,
        error: false,
      },
    },
  },
  lists: {
    preview: {
      loading: false,
      item: undefined,
      error: false,
    },
    overview: {
      loading: false,
      item: undefined,
      error: false,
    },
    list: {
      loading: false,
      items: [],
      error: false,
    },
    messages: {
      messages: {
        items: [],
        loading: false,
        error: false,
      },
      booking: undefined,
    },
    filters: {
      chosenDomains: [],
      showMessages: 'all',
      showCancelled: 'all',
      search: undefined,
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/reminders/defaultState.js